type DomainTransformationMap = Record<string, string>;

const DOMAIN_TRANSFORMATIONS: DomainTransformationMap = {
  'ELD California Edition': 'ELD',
  ELD: 'ELD',
};

export const transformDomainBySubject = (
  domain: string,
  subject?: string,
): string => {
  if (!subject) {
    return domain;
  }

  // Fallback to simple domain transformation
  return DOMAIN_TRANSFORMATIONS[subject] || domain;
};
